import React, {
  useState,
  useContext,
  useEffect
} from 'react';

import PropTypes from 'prop-types';

import WithPopup from 'src/HOC/WithPopup/WithPopup';

import {
  checkInputValidity,
  isMobileView
} from 'src/Utility/utility';

import {
  checkIsValidOTP
} from 'src/Services/Services';

import {
  SalesContext
} from 'src/Context/SalesContext';

import {
  tagOnOtpScreenLoad,
  tagOnUserEnterOtp,
  tagOnOtpError
} from 'src/Tagging/SalesTagging';

import OTPInput from './Components/OTPInput';

import Blocked from './Components/Blocked';

import './OtpScreen.css';

const OtpScreen = (props) => {

  const context = useContext(SalesContext);

  const contentStyleDesktop = {
    position: 'absolute',
    margin: 'auto',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '100%'
  };

  const contentStyleMobile = {
    margin: 'auto'
  };

  const contentStyleDesktopBlocked = {
    position: 'absolute',
    margin: 'auto',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '100%',
    background: 'white',
    height: '100%'
  };

  const contentStyleMobileBlocked = {
    position: 'absolute',
    margin: 'auto',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '100%',
    background: 'white',
    height: '100%'
  };

  const [ otpValue, setOtpValue ] = useState(
    {
      name: '*Enter OTP',
      type: 'input',
      value: '',
      validations: {
        required: true,
        minLength: props.otpLength,
        invalidMessage: 'Looks like you entered an invalid OTP. Please try again.',
        resendMessage: 'Your One-Time PIN has been resent. Please check your inbox.'
      },
      config: {
        type: 'number',
        required: true
      },
      isValid: false,
      isTouched: false,
      showError: false,
      showResend: false,
      isAccountBlocked: false
    }
  );

  const [ otpAttempts, setOtpAttempts ] = useState(0);

  const warningMsgOnclick = () => {
    const changedComponent = { ...otpValue };
    changedComponent.showError = false;
    changedComponent.showResend = false;
    setOtpValue(changedComponent);
  };

  const infoMsgOnclick = () => {
    const changedComponent = { ...otpValue };
    changedComponent.showError = false;
    changedComponent.showResend = false;
    setOtpValue(changedComponent);
  };

  const [ isOtpAttemptFail, setIsOtpAttemptFail ] = useState(false);

  const otpHandler = (value) => {
    if (value.length === 1) {
      tagOnUserEnterOtp();
    }
    const changedComponent = { ...otpValue };
    changedComponent.value = value;
    changedComponent.validations.invalidMessage = 'Please enter a valid OTP';
    changedComponent.isValid = checkInputValidity(changedComponent.value, changedComponent.validations);
    changedComponent.isTouched = true;
    setOtpValue(changedComponent);
  };

  const isValidOTP = () => {
    context.setShowSpinner(true);
    checkIsValidOTP(otpValue.value, context).then(res => {

      if (res.result && context.isUserExisting) {

        context.setUserDetails({ key: 'firstName', value: res?.result?.customerDetails?.fullname.split(' ')[0] });
        context.setUserDetails({ key: 'lastName', value: res?.result?.customerDetails?.fullname.split(' ')[1] });
        context.setUserDetails({ key: 'email', value: res?.result?.customerDetails?.emailAddress });
        context.setUserDetails({ key: 'contactNumber', value: res?.result?.customerDetails?.phoneNumber });
        context.setUserDetails({ key: 'billingAccountNumber', value: res?.result?.customerDetails?.billingAccountNumber });

        window.scrollTo(0, 0);
        context.setShowSpinner(false);
        props.history.push('/cloud/fibre/sales/review-order');
      }
    })
      .catch(error => {
        context.setShowSpinner(true);

        if (error?.status === 422) {
          const changedComponent = { ...otpValue };
          changedComponent.validations.invalidMessage = error?.data?.message;
          changedComponent.showError = true;
          setOtpValue(changedComponent);
          tagOnOtpError(error?.data?.message);
        } else if(error?.status === 423){
          setIsOtpAttemptFail(true);
          tagOnOtpError(error?.data?.message);
        } else {
          window.scrollTo(0, 0);
          props.history.push('/cloud/fibre/sales/error');
        }
        context.setShowSpinner(false);
        setOtpAttempts(error.data.attemptCount);
      });
  };

  const getOtpMessage = () => {
    let message = 'Please enter the OTP';
    if (props?.contactNumberSent && props?.contactEmailSent && props?.contactNumberObscure && props?.contactEmailObscure) {
      message += ` sent to ${ props?.contactNumberObscure } and ${ props?.contactEmailObscure }.`;
    } else if (!props?.contactNumberSent && props?.contactEmailObscure) {
      message += ` sent to ${ props?.contactEmailObscure }.`;
    } else if (props?.contactNumberObscure) {
      message += ` sent to ${ props?.contactNumberObscure }.`;
    }

    return message;
  };

  useEffect(() => {
    tagOnOtpScreenLoad(context.userDetails && context.existingUserContactNumber);
  }, []);

  useEffect(() => {
    if (props.otpData?.isResend) {
      const changedComponent = { ...otpValue };
      changedComponent.showError = false;
      changedComponent.showResend = true;
      setOtpValue(changedComponent);
    }
    if (props.otpData?.sendAttempts > 3) {
      const changedComponent = { ...otpValue };
      changedComponent.showError = false;
      changedComponent.showResend = false;
      changedComponent.isAccountBlocked = true;
      setOtpValue(changedComponent);
    }
  }, [ props.otpData ]);

  const resendOtp =() => {
    props.resendOtp(true);
  };

  useEffect(() => {
    if (otpAttempts > 2) {
      const changedComponent = { ...otpValue };
      changedComponent.showError = false;
      changedComponent.showResend = false;
      changedComponent.isAccountBlocked = true;
      setOtpValue(changedComponent);
    }
  }, [ otpAttempts ]);

  return (
    <div>
      {
        !(isOtpAttemptFail || otpValue.isAccountBlocked) ?
          <WithPopup
            warningMsg={otpValue.showError ? otpValue.validations.invalidMessage : ''}
            warningMsgOnclick={warningMsgOnclick}
            infoMessage={otpValue.showResend ? otpValue.validations.resendMessage : ''}
            infoMsgOnclick={infoMsgOnclick}
            contentStyle={isMobileView() ? contentStyleMobile : contentStyleDesktop}>
            <div className="otp-screen-wrapper">

              <button onClick={props.close}
                className="otp-screen-close-button">
                x
              </button>

              <div className="otp-screen-main-section">

                <div className="otp-screen-text-section">

                  <div className="enter-otp-text">
                    Please enter your {props.otpLength}-digit OTP
                  </div>

                  <div className="otp-sent-text" >
                    {getOtpMessage()}
                  </div>

                  <div className="otp-input-and-send-msg">

                    <div className="otp-input-wrapper">
                      <OTPInput
                        noOfDigits={props.otpLength}
                        otpHandler={otpHandler}
                      />
                    </div>

                    <div className="send-to-text">
                      <div
                        className="resend-otp-link"
                        onClick={resendOtp}>
                        Re-send OTP
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="otp-screen-footer-section">
                <div className="otp-screen-footer-btns">
                  <button
                    disabled={!otpValue.isValid}
                    className={'verify help-me-choose-plan-next-button'}
                    onClick={isValidOTP}
                  >
                    Submit OTP
                  </button>
                </div>
              </div>

            </div>
          </WithPopup>
          :
          <WithPopup contentStyle={isMobileView() ? contentStyleMobileBlocked : contentStyleDesktopBlocked}>
            <Blocked close={props.close}/>
          </WithPopup>
      }
    </div>

  );
};

OtpScreen.propTypes = {
  close: PropTypes.func.isRequired,
  resendOtp: PropTypes.func.isRequired,
  contactEmailSent: PropTypes.string.isRequired,
  contactNumberSent: PropTypes.string.isRequired,
  contactEmailObscure: PropTypes.string.isRequired,
  contactNumberObscure: PropTypes.string.isRequired,
  otpLength: PropTypes.number,
  otpData: PropTypes.shape({
    sendAttempts: PropTypes.number,
    isResend: PropTypes.bool,
    destinationResults: PropTypes.array
  })
};

OtpScreen.defaultProps = {
  otpLength: 4
};

export default OtpScreen;